import { render, staticRenderFns } from "./createLead.vue?vue&type=template&id=1ec45a06"
import script from "./createLead.vue?vue&type=script&lang=js"
export * from "./createLead.vue?vue&type=script&lang=js"
import style0 from "./createLead.vue?vue&type=style&index=0&id=1ec45a06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports